import { render, staticRenderFns } from "./CardStoreAddress.vue?vue&type=template&id=6a3f6952&scoped=true&"
import script from "./CardStoreAddress.vue?vue&type=script&lang=js&"
export * from "./CardStoreAddress.vue?vue&type=script&lang=js&"
import style0 from "./CardStoreAddress.vue?vue&type=style&index=0&id=6a3f6952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3f6952",
  null
  
)

export default component.exports